// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================================
   SHARED
   ============================================================ */

.custom-alert-icon-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.custom-alert-icon-wrapper svg {
  width: 30px;
  height: 30px;
}

.notification-success {
  --alert-color: #2e9d68;
  --alert-light: #e5f6ed;
  --alert-border: #bff1db;
  --alert-button: #bff1db;
}

.notification-error {
  --alert-color: #d9534f;
  --alert-light: #fde9e8;
  --alert-border: #f2c4c4;
  --alert-button: #f2c4c4;
}

.notification-info {
  --alert-color: #5c61c9;
  --alert-light: #ecebff;
  --alert-border: #d5d1fd;
  --alert-button: #d5d1fd;
}


/* ============================================================
   MODAL BACKDROP
   ============================================================ */

.custom-alert-modal-backdrop {
  position: fixed;
  inset: 0;
  /* Above FeeVerificationModal (10500) and toasts (10600) so confirm stays a real dialog */
  z-index: 12000;

  display: flex;
  align-items: center;
  justify-content: center;

  padding: 24px;

  background: rgba(30, 30, 40, 0.58);

  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  animation: customAlertBackdropIn 0.2s ease-out;
}


/* ============================================================
   MODAL
   ============================================================ */

.custom-alert-modal {
  position: relative;

  width: 100%;
  max-width: 470px;

  background: #fdfbf8;

  border-radius: 22px;

  padding: 42px 34px 30px;

  box-shadow:
    0 24px 70px rgba(0, 0, 0, 0.18),
    0 6px 20px rgba(0, 0, 0, 0.08);

  text-align: center;

  animation: customAlertModalIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);
}


/* ============================================================
   MODAL CLOSE BUTTON
   ============================================================ */

.custom-alert-modal-close {
  position: absolute;
  top: 17px;
  right: 17px;

  width: 34px;
  height: 34px;

  display: flex;
  align-items: center;
  justify-content: center;

  border: none;
  border-radius: 50%;

  background: transparent;

  color: #777;

  cursor: pointer;

  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.custom-alert-modal-close:hover {
  background: #f0eeeb;
  color: #333;

  transform: rotate(5deg);
}

.custom-alert-modal-close:active {
  transform: scale(0.92);
}

.custom-alert-modal-close svg {
  width: 15px;
  height: 15px;
}


/* ============================================================
   MODAL ICON
   ============================================================ */

.custom-alert-modal .custom-alert-icon-wrapper {
  width: 78px;
  height: 78px;

  margin: 0 auto 24px;

  border-radius: 50%;

  background: var(--alert-light);

  color: var(--alert-color);

  box-shadow:
    0 0 0 8px rgba(255, 255, 255, 0.7),
    0 8px 20px rgba(0, 0, 0, 0.06);

  animation: customAlertIconIn 0.35s ease-out;
}

.custom-alert-modal .custom-alert-icon-wrapper svg {
  width: 38px;
  height: 38px;
}


/* ============================================================
   MODAL CONTENT
   ============================================================ */

.custom-alert-modal-content {
  padding: 0 8px;
}

.custom-alert-modal-content h3,
.custom-alert-modal-message {
  margin: 0;

  color: #2f2f35;

  font-size: 20px;
  font-weight: 600;
  line-height: 1.55;

  letter-spacing: -0.15px;

  word-break: break-word;
}


/* ============================================================
   MODAL ACTION
   ============================================================ */

.custom-alert-modal-actions {
  margin-top: 30px;
  display: flex;
  gap: 10px;
}

.custom-alert-cancel-button {
  flex: 1 1;
  min-height: 48px;
  border: 1px solid #e0dce8;
  border-radius: 11px;
  padding: 11px 20px;
  background: #fff;
  color: #403b55;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
}

.custom-alert-cancel-button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.custom-alert-confirm-button {
  flex: 1 1;

  min-height: 48px;

  border: 1px solid transparent;
  border-radius: 11px;

  padding: 11px 20px;

  color: #34333b;

  font-size: 15px;
  font-weight: 600;

  cursor: pointer;

  transition:
    transform 0.15s ease,
    box-shadow 0.2s ease,
    filter 0.2s ease;
}

.custom-alert-confirm-button.notification-success {
  background: #bff1db;
  border-color: #bff1db;
}

.custom-alert-confirm-button.notification-error {
  background: #f2c4c4;
  border-color: #f2c4c4;
}

.custom-alert-confirm-button.notification-info {
  background: #d5d1fd;
  border-color: #d5d1fd;
}

.custom-alert-confirm-button:hover {
  filter: brightness(0.97);

  box-shadow:
    0 5px 14px rgba(0, 0, 0, 0.08);

  transform: translateY(-1px);
}

.custom-alert-confirm-button:active {
  transform: translateY(0) scale(0.99);

  box-shadow: none;
}


/* ============================================================
   TOAST
   ============================================================ */

.custom-alert-toast {
  position: fixed;

  top: 64px;
  right: 24px;

  z-index: 10600;

  width: min(420px, calc(100vw - 32px));

  display: flex;
  align-items: flex-start;

  gap: 14px;

  padding: 16px 16px 15px;

  background: #fdfbf8;

  border: 1px solid #ebe7e1;

  border-radius: 15px;

  box-shadow:
    0 14px 40px rgba(0, 0, 0, 0.13),
    0 3px 10px rgba(0, 0, 0, 0.06);

  overflow: hidden;

  animation:
    customAlertToastIn 0.4s cubic-bezier(0.2, 0.8, 0.2, 1)
    forwards;
}


/* ============================================================
   TOAST STATUS STRIPE
   ============================================================ */

.custom-alert-toast::before {
  content: "";

  position: absolute;

  top: 0;
  left: 0;
  bottom: 0;

  width: 4px;

  background: var(--alert-color);
}


/* ============================================================
   TOAST ICON
   ============================================================ */

.custom-alert-toast-icon {
  width: 38px;
  height: 38px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  border-radius: 50%;

  background: var(--alert-light);

  color: var(--alert-color);
}

.custom-alert-toast-icon svg {
  width: 19px;
  height: 19px;
}


/* ============================================================
   TOAST CONTENT
   ============================================================ */

.custom-alert-toast-content {
  flex: 1 1;

  min-width: 0;

  padding-top: 2px;
}

.custom-alert-toast-message {
  color: #35343a;

  font-size: 14px;
  font-weight: 500;

  line-height: 1.5;

  word-break: break-word;
}


/* ============================================================
   TOAST CLOSE
   ============================================================ */

.custom-alert-toast-close {
  width: 28px;
  height: 28px;

  flex-shrink: 0;

  display: flex;
  align-items: center;
  justify-content: center;

  margin-top: -2px;

  border: none;
  border-radius: 50%;

  background: transparent;

  color: #8a8782;

  cursor: pointer;

  transition:
    background-color 0.2s ease,
    color 0.2s ease,
    transform 0.2s ease;
}

.custom-alert-toast-close:hover {
  background: #efede9;

  color: #333;

  transform: rotate(5deg);
}

.custom-alert-toast-close:active {
  transform: scale(0.9);
}

.custom-alert-toast-close svg {
  width: 13px;
  height: 13px;
}


/* ============================================================
   TOAST PROGRESS BAR
   ============================================================ */

.custom-alert-toast-progress {
  width: 100%;
  height: 3px;

  margin-top: 11px;

  overflow: hidden;

  border-radius: 5px;

  background: #ece9e5;
}

.custom-alert-toast-progress-bar {
  width: 100%;
  height: 100%;

  background: var(--alert-color);

  transform-origin: left center;

  animation: customAlertToastProgress 10s linear forwards;
}


/* ============================================================
   ANIMATIONS
   ============================================================ */

@keyframes customAlertBackdropIn {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}


@keyframes customAlertModalIn {
  from {
    opacity: 0;
    transform: translateY(12px) scale(0.96);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}


@keyframes customAlertIconIn {
  from {
    opacity: 0;
    transform: scale(0.7);
  }

  to {
    opacity: 1;
    transform: scale(1);
  }
}


@keyframes customAlertToastIn {
  from {
    opacity: 0;
    transform: translateX(100%);
  }

  to {
    opacity: 1;
    transform: translateX(0);
  }
}


@keyframes customAlertToastProgress {
  from {
    transform: scaleX(1);
  }

  to {
    transform: scaleX(0);
  }
}


/* ============================================================
   RESPONSIVE
   ============================================================ */

@media (max-width: 576px) {
  .custom-alert-modal-backdrop {
    padding: 16px;
  }

  .custom-alert-modal {
    padding: 38px 22px 24px;

    border-radius: 18px;
  }

  .custom-alert-modal .custom-alert-icon-wrapper {
    width: 68px;
    height: 68px;
  }

  .custom-alert-modal .custom-alert-icon-wrapper svg {
    width: 32px;
    height: 32px;
  }

  .custom-alert-modal-content h3 {
    font-size: 18px;
    line-height: 1.5;
  }

  .custom-alert-toast {
    top: 16px;
    right: 16px;

    width: calc(100vw - 32px);
  }
}


/* ============================================================
   REDUCED MOTION
   ============================================================ */

@media (prefers-reduced-motion: reduce) {
  .custom-alert-modal-backdrop,
  .custom-alert-modal,
  .custom-alert-toast,
  .custom-alert-modal .custom-alert-icon-wrapper,
  .custom-alert-toast-progress-bar {
    animation: none;
  }

  .custom-alert-toast-progress-bar {
    transform: scaleX(0);
  }
}`, "",{"version":3,"sources":["webpack://./src/components/CustomAlerts.css"],"names":[],"mappings":"AAAA;;iEAEiE;;AAEjE;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;AACzB;;;AAGA;;iEAEiE;;AAEjE;EACE,eAAe;EACf,QAAQ;EACR,yFAAyF;EACzF,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,aAAa;;EAEb,kCAAkC;;EAElC,0BAA0B;EAC1B,kCAAkC;;EAElC,8CAA8C;AAChD;;;AAGA;;iEAEiE;;AAEjE;EACE,kBAAkB;;EAElB,WAAW;EACX,gBAAgB;;EAEhB,mBAAmB;;EAEnB,mBAAmB;;EAEnB,uBAAuB;;EAEvB;;kCAEgC;;EAEhC,kBAAkB;;EAElB,kEAAkE;AACpE;;;AAGA;;iEAEiE;;AAEjE;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;;EAEX,WAAW;EACX,YAAY;;EAEZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,YAAY;EACZ,kBAAkB;;EAElB,uBAAuB;;EAEvB,WAAW;;EAEX,eAAe;;EAEf;;;uBAGqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;;EAEX,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,YAAY;;EAEZ,mBAAmB;;EAEnB,kBAAkB;;EAElB,8BAA8B;;EAE9B,yBAAyB;;EAEzB;;kCAEgC;;EAEhC,2CAA2C;AAC7C;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;;iEAEiE;;AAEjE;EACE,cAAc;AAChB;;AAEA;;EAEE,SAAS;;EAET,cAAc;;EAEd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;;EAEjB,uBAAuB;;EAEvB,sBAAsB;AACxB;;;AAGA;;iEAEiE;;AAEjE;EACE,gBAAgB;EAChB,aAAa;EACb,SAAS;AACX;;AAEA;EACE,SAAO;EACP,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAO;;EAEP,gBAAgB;;EAEhB,6BAA6B;EAC7B,mBAAmB;;EAEnB,kBAAkB;;EAElB,cAAc;;EAEd,eAAe;EACf,gBAAgB;;EAEhB,eAAe;;EAEf;;;oBAGkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,wBAAwB;;EAExB;kCACgC;;EAEhC,2BAA2B;AAC7B;;AAEA;EACE,oCAAoC;;EAEpC,gBAAgB;AAClB;;;AAGA;;iEAEiE;;AAEjE;EACE,eAAe;;EAEf,SAAS;EACT,WAAW;;EAEX,cAAc;;EAEd,qCAAqC;;EAErC,aAAa;EACb,uBAAuB;;EAEvB,SAAS;;EAET,uBAAuB;;EAEvB,mBAAmB;;EAEnB,yBAAyB;;EAEzB,mBAAmB;;EAEnB;;kCAEgC;;EAEhC,gBAAgB;;EAEhB;;YAEU;AACZ;;;AAGA;;iEAEiE;;AAEjE;EACE,WAAW;;EAEX,kBAAkB;;EAElB,MAAM;EACN,OAAO;EACP,SAAS;;EAET,UAAU;;EAEV,8BAA8B;AAChC;;;AAGA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,kBAAkB;;EAElB,8BAA8B;;EAE9B,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;;iEAEiE;;AAEjE;EACE,SAAO;;EAEP,YAAY;;EAEZ,gBAAgB;AAClB;;AAEA;EACE,cAAc;;EAEd,eAAe;EACf,gBAAgB;;EAEhB,gBAAgB;;EAEhB,sBAAsB;AACxB;;;AAGA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,YAAY;;EAEZ,cAAc;;EAEd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;;EAEvB,gBAAgB;;EAEhB,YAAY;EACZ,kBAAkB;;EAElB,uBAAuB;;EAEvB,cAAc;;EAEd,eAAe;;EAEf;;;uBAGqB;AACvB;;AAEA;EACE,mBAAmB;;EAEnB,WAAW;;EAEX,uBAAuB;AACzB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;;AAGA;;iEAEiE;;AAEjE;EACE,WAAW;EACX,WAAW;;EAEX,gBAAgB;;EAEhB,gBAAgB;;EAEhB,kBAAkB;;EAElB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;;EAEZ,8BAA8B;;EAE9B,6BAA6B;;EAE7B,uDAAuD;AACzD;;;AAGA;;iEAEiE;;AAEjE;EACE;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;;AAGA;EACE;IACE,UAAU;IACV,uCAAuC;EACzC;;EAEA;IACE,UAAU;IACV,iCAAiC;EACnC;AACF;;;AAGA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF;;;AAGA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;;EAEA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;;AAGA;EACE;IACE,oBAAoB;EACtB;;EAEA;IACE,oBAAoB;EACtB;AACF;;;AAGA;;iEAEiE;;AAEjE;EACE;IACE,aAAa;EACf;;EAEA;IACE,uBAAuB;;IAEvB,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,SAAS;IACT,WAAW;;IAEX,yBAAyB;EAC3B;AACF;;;AAGA;;iEAEiE;;AAEjE;EACE;;;;;IAKE,eAAe;EACjB;;EAEA;IACE,oBAAoB;EACtB;AACF","sourcesContent":["/* ============================================================\n   SHARED\n   ============================================================ */\n\n.custom-alert-icon-wrapper {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-shrink: 0;\n}\n\n.custom-alert-icon-wrapper svg {\n  width: 30px;\n  height: 30px;\n}\n\n.notification-success {\n  --alert-color: #2e9d68;\n  --alert-light: #e5f6ed;\n  --alert-border: #bff1db;\n  --alert-button: #bff1db;\n}\n\n.notification-error {\n  --alert-color: #d9534f;\n  --alert-light: #fde9e8;\n  --alert-border: #f2c4c4;\n  --alert-button: #f2c4c4;\n}\n\n.notification-info {\n  --alert-color: #5c61c9;\n  --alert-light: #ecebff;\n  --alert-border: #d5d1fd;\n  --alert-button: #d5d1fd;\n}\n\n\n/* ============================================================\n   MODAL BACKDROP\n   ============================================================ */\n\n.custom-alert-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  /* Above FeeVerificationModal (10500) and toasts (10600) so confirm stays a real dialog */\n  z-index: 12000;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  padding: 24px;\n\n  background: rgba(30, 30, 40, 0.58);\n\n  backdrop-filter: blur(4px);\n  -webkit-backdrop-filter: blur(4px);\n\n  animation: customAlertBackdropIn 0.2s ease-out;\n}\n\n\n/* ============================================================\n   MODAL\n   ============================================================ */\n\n.custom-alert-modal {\n  position: relative;\n\n  width: 100%;\n  max-width: 470px;\n\n  background: #fdfbf8;\n\n  border-radius: 22px;\n\n  padding: 42px 34px 30px;\n\n  box-shadow:\n    0 24px 70px rgba(0, 0, 0, 0.18),\n    0 6px 20px rgba(0, 0, 0, 0.08);\n\n  text-align: center;\n\n  animation: customAlertModalIn 0.25s cubic-bezier(0.2, 0.8, 0.2, 1);\n}\n\n\n/* ============================================================\n   MODAL CLOSE BUTTON\n   ============================================================ */\n\n.custom-alert-modal-close {\n  position: absolute;\n  top: 17px;\n  right: 17px;\n\n  width: 34px;\n  height: 34px;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border: none;\n  border-radius: 50%;\n\n  background: transparent;\n\n  color: #777;\n\n  cursor: pointer;\n\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease,\n    transform 0.2s ease;\n}\n\n.custom-alert-modal-close:hover {\n  background: #f0eeeb;\n  color: #333;\n\n  transform: rotate(5deg);\n}\n\n.custom-alert-modal-close:active {\n  transform: scale(0.92);\n}\n\n.custom-alert-modal-close svg {\n  width: 15px;\n  height: 15px;\n}\n\n\n/* ============================================================\n   MODAL ICON\n   ============================================================ */\n\n.custom-alert-modal .custom-alert-icon-wrapper {\n  width: 78px;\n  height: 78px;\n\n  margin: 0 auto 24px;\n\n  border-radius: 50%;\n\n  background: var(--alert-light);\n\n  color: var(--alert-color);\n\n  box-shadow:\n    0 0 0 8px rgba(255, 255, 255, 0.7),\n    0 8px 20px rgba(0, 0, 0, 0.06);\n\n  animation: customAlertIconIn 0.35s ease-out;\n}\n\n.custom-alert-modal .custom-alert-icon-wrapper svg {\n  width: 38px;\n  height: 38px;\n}\n\n\n/* ============================================================\n   MODAL CONTENT\n   ============================================================ */\n\n.custom-alert-modal-content {\n  padding: 0 8px;\n}\n\n.custom-alert-modal-content h3,\n.custom-alert-modal-message {\n  margin: 0;\n\n  color: #2f2f35;\n\n  font-size: 20px;\n  font-weight: 600;\n  line-height: 1.55;\n\n  letter-spacing: -0.15px;\n\n  word-break: break-word;\n}\n\n\n/* ============================================================\n   MODAL ACTION\n   ============================================================ */\n\n.custom-alert-modal-actions {\n  margin-top: 30px;\n  display: flex;\n  gap: 10px;\n}\n\n.custom-alert-cancel-button {\n  flex: 1;\n  min-height: 48px;\n  border: 1px solid #e0dce8;\n  border-radius: 11px;\n  padding: 11px 20px;\n  background: #fff;\n  color: #403b55;\n  font-size: 15px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.custom-alert-cancel-button:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.custom-alert-confirm-button {\n  flex: 1;\n\n  min-height: 48px;\n\n  border: 1px solid transparent;\n  border-radius: 11px;\n\n  padding: 11px 20px;\n\n  color: #34333b;\n\n  font-size: 15px;\n  font-weight: 600;\n\n  cursor: pointer;\n\n  transition:\n    transform 0.15s ease,\n    box-shadow 0.2s ease,\n    filter 0.2s ease;\n}\n\n.custom-alert-confirm-button.notification-success {\n  background: #bff1db;\n  border-color: #bff1db;\n}\n\n.custom-alert-confirm-button.notification-error {\n  background: #f2c4c4;\n  border-color: #f2c4c4;\n}\n\n.custom-alert-confirm-button.notification-info {\n  background: #d5d1fd;\n  border-color: #d5d1fd;\n}\n\n.custom-alert-confirm-button:hover {\n  filter: brightness(0.97);\n\n  box-shadow:\n    0 5px 14px rgba(0, 0, 0, 0.08);\n\n  transform: translateY(-1px);\n}\n\n.custom-alert-confirm-button:active {\n  transform: translateY(0) scale(0.99);\n\n  box-shadow: none;\n}\n\n\n/* ============================================================\n   TOAST\n   ============================================================ */\n\n.custom-alert-toast {\n  position: fixed;\n\n  top: 64px;\n  right: 24px;\n\n  z-index: 10600;\n\n  width: min(420px, calc(100vw - 32px));\n\n  display: flex;\n  align-items: flex-start;\n\n  gap: 14px;\n\n  padding: 16px 16px 15px;\n\n  background: #fdfbf8;\n\n  border: 1px solid #ebe7e1;\n\n  border-radius: 15px;\n\n  box-shadow:\n    0 14px 40px rgba(0, 0, 0, 0.13),\n    0 3px 10px rgba(0, 0, 0, 0.06);\n\n  overflow: hidden;\n\n  animation:\n    customAlertToastIn 0.4s cubic-bezier(0.2, 0.8, 0.2, 1)\n    forwards;\n}\n\n\n/* ============================================================\n   TOAST STATUS STRIPE\n   ============================================================ */\n\n.custom-alert-toast::before {\n  content: \"\";\n\n  position: absolute;\n\n  top: 0;\n  left: 0;\n  bottom: 0;\n\n  width: 4px;\n\n  background: var(--alert-color);\n}\n\n\n/* ============================================================\n   TOAST ICON\n   ============================================================ */\n\n.custom-alert-toast-icon {\n  width: 38px;\n  height: 38px;\n\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  border-radius: 50%;\n\n  background: var(--alert-light);\n\n  color: var(--alert-color);\n}\n\n.custom-alert-toast-icon svg {\n  width: 19px;\n  height: 19px;\n}\n\n\n/* ============================================================\n   TOAST CONTENT\n   ============================================================ */\n\n.custom-alert-toast-content {\n  flex: 1;\n\n  min-width: 0;\n\n  padding-top: 2px;\n}\n\n.custom-alert-toast-message {\n  color: #35343a;\n\n  font-size: 14px;\n  font-weight: 500;\n\n  line-height: 1.5;\n\n  word-break: break-word;\n}\n\n\n/* ============================================================\n   TOAST CLOSE\n   ============================================================ */\n\n.custom-alert-toast-close {\n  width: 28px;\n  height: 28px;\n\n  flex-shrink: 0;\n\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  margin-top: -2px;\n\n  border: none;\n  border-radius: 50%;\n\n  background: transparent;\n\n  color: #8a8782;\n\n  cursor: pointer;\n\n  transition:\n    background-color 0.2s ease,\n    color 0.2s ease,\n    transform 0.2s ease;\n}\n\n.custom-alert-toast-close:hover {\n  background: #efede9;\n\n  color: #333;\n\n  transform: rotate(5deg);\n}\n\n.custom-alert-toast-close:active {\n  transform: scale(0.9);\n}\n\n.custom-alert-toast-close svg {\n  width: 13px;\n  height: 13px;\n}\n\n\n/* ============================================================\n   TOAST PROGRESS BAR\n   ============================================================ */\n\n.custom-alert-toast-progress {\n  width: 100%;\n  height: 3px;\n\n  margin-top: 11px;\n\n  overflow: hidden;\n\n  border-radius: 5px;\n\n  background: #ece9e5;\n}\n\n.custom-alert-toast-progress-bar {\n  width: 100%;\n  height: 100%;\n\n  background: var(--alert-color);\n\n  transform-origin: left center;\n\n  animation: customAlertToastProgress 10s linear forwards;\n}\n\n\n/* ============================================================\n   ANIMATIONS\n   ============================================================ */\n\n@keyframes customAlertBackdropIn {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: 1;\n  }\n}\n\n\n@keyframes customAlertModalIn {\n  from {\n    opacity: 0;\n    transform: translateY(12px) scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateY(0) scale(1);\n  }\n}\n\n\n@keyframes customAlertIconIn {\n  from {\n    opacity: 0;\n    transform: scale(0.7);\n  }\n\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n\n\n@keyframes customAlertToastIn {\n  from {\n    opacity: 0;\n    transform: translateX(100%);\n  }\n\n  to {\n    opacity: 1;\n    transform: translateX(0);\n  }\n}\n\n\n@keyframes customAlertToastProgress {\n  from {\n    transform: scaleX(1);\n  }\n\n  to {\n    transform: scaleX(0);\n  }\n}\n\n\n/* ============================================================\n   RESPONSIVE\n   ============================================================ */\n\n@media (max-width: 576px) {\n  .custom-alert-modal-backdrop {\n    padding: 16px;\n  }\n\n  .custom-alert-modal {\n    padding: 38px 22px 24px;\n\n    border-radius: 18px;\n  }\n\n  .custom-alert-modal .custom-alert-icon-wrapper {\n    width: 68px;\n    height: 68px;\n  }\n\n  .custom-alert-modal .custom-alert-icon-wrapper svg {\n    width: 32px;\n    height: 32px;\n  }\n\n  .custom-alert-modal-content h3 {\n    font-size: 18px;\n    line-height: 1.5;\n  }\n\n  .custom-alert-toast {\n    top: 16px;\n    right: 16px;\n\n    width: calc(100vw - 32px);\n  }\n}\n\n\n/* ============================================================\n   REDUCED MOTION\n   ============================================================ */\n\n@media (prefers-reduced-motion: reduce) {\n  .custom-alert-modal-backdrop,\n  .custom-alert-modal,\n  .custom-alert-toast,\n  .custom-alert-modal .custom-alert-icon-wrapper,\n  .custom-alert-toast-progress-bar {\n    animation: none;\n  }\n\n  .custom-alert-toast-progress-bar {\n    transform: scaleX(0);\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
